module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/footer/footer.component.css
// module id = ./src/app/components/footer/footer.component.css
// module chunks = main